export default __webpack_public_path__ + "static/media/arrow_right.8203ff77.svg";